import moment from 'moment/moment';
import {StyledBodyCell} from '../StyledBodyCell';
import TableRow from "@mui/material/TableRow";
import {getTraceName} from "../../enum/traceAction";
import Link from "@mui/material/Link";
import {Box} from "@mui/material";

export const BoxTraceTableRow = ({trace}) => {
    return <TableRow>
        <StyledBodyCell>{trace.lot.name}</StyledBodyCell>
        <StyledBodyCell>{trace.box.hash}</StyledBodyCell>
        <StyledBodyCell>{getTraceName(trace.action)}</StyledBodyCell>
        <StyledBodyCell>
            <Link href={`${process.env.REACT_APP_VIEW_BLOCK_URL}/${trace.transaction}`} target="_blank">
                {trace.transaction}
            </Link>
        </StyledBodyCell>
        <StyledBodyCell>
            <Box>{moment.utc(trace.created).format('DD/MM/YYYY')}</Box>
            <Box>{moment.utc(trace.created).format('hh:mm:ss')}</Box>
        </StyledBodyCell>
    </TableRow>;
}
